import { RadioOption } from 'components/ui/radio-group'

export const ONBOARDING_COMPANY_SIZE_OPTIONS: RadioOption[] = [
  {
    id: 1,
    title: 'onboarding_questionnaire_selection_self_employed',
    description: 'onboarding_questionnaire_selection_solopreneur',
    value: 'Self Employed',
  },
  {
    id: 2,
    title: 'onboarding_questionnaire_selection_small',
    description: 'onboarding_questionnaire_selection_small_subheading',
    value: 'Small',
  },
  {
    id: 3,
    title: 'onboarding_questionnaire_selection_medium',
    description: 'onboarding_questionnaire_selection_medium_subheading',
    value: 'Medium',
  },
  {
    id: 4,
    title: 'onboarding_questionnaire_selection_large',
    description: 'onboarding_questionnaire_selection_large_subheading',
    value: 'Large',
  },
  {
    id: 5,
    title: 'onboarding_questionnaire_selection_enterprise',
    description: 'onboarding_questionnaire_selection_enterprise_subheading',
    value: 'Enterprise',
  },
]
